import { Link } from 'react-router-dom'
import Modal from '../../../core/components/UI/Modal'
import { toastError, toastSuccess } from '../../../helper'
import useRequestsActions from '../../hooks/useRequestsActions'
import { useRef } from 'react'
import { FaSpinner } from 'react-icons/fa'

export default function ModalRequestsOptions({ isOpen, onClose, request }) {
  const statusRef = useRef(null)
  const { changeSponsorRequestStatus, inProgress } = useRequestsActions()
  async function handleOnSubmit() {
    try {
      const payload = {
        status: statusRef.current.value,
      }

      const message = await changeSponsorRequestStatus(request?.id, payload)

      if (message) {
        toastSuccess(message)
      }
    } catch (error) {
      toastError(error.response.data.error)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`min-w-[512px] border-2 border-muted-500 bg-white p-2 text-xs`}
    >
      <select
        ref={statusRef}
        className="mb-2 w-full border-2 bg-white px-4 py-2 outline-none focus:bg-white"
        defaultValue={request?.status}
      >
        <option value={'OPEN'}>مفتوح</option>
        <option value={'IN_PROGRESS'}>في طور المعالجة </option>
        <option value={'REJECTED'}>مرفوض</option>
        <option value={'ACCEPTED'}>مقبول</option>
      </select>
      <button
        type="button"
        onClick={handleOnSubmit}
        disabled={inProgress}
        className="flex w-full items-center justify-center gap-2 border-2 border-primary-600 bg-primary-600 px-6 py-3 font-bold text-white outline-none hover:border-accent-600 hover:bg-accent-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
      >
        {inProgress ? (
          <>
            <FaSpinner
              size={16}
              className="animate-spin"
            />
            <span>جاري تحديث حالة طلب الراعي ... </span>
          </>
        ) : (
          <span> تحديث حالة طلب الراعي </span>
        )}
      </button>
    </Modal>
  )
}
